import { InternalAxiosRequestConfig } from 'axios';

import { forceCSRFToken, forceJsonHeaders } from 'v2/interceptors';
import { runInsideLock } from 'v2/concurrent';

import { authStorage } from './storages';
import { runRefreshProcess } from './actions';
import { type ISamoletConfiguration } from './types';

function forceAuthenticationHeader(config: InternalAxiosRequestConfig) {
  const authParams = authStorage.getJwtAuthParams();
  if (authParams?.access) {
    config.headers.Authorization = `Bearer ${authParams.access}`;
  }
}

export function requestInterceptor(config: InternalAxiosRequestConfig) {
  forceJsonHeaders(config);
  forceAuthenticationHeader(config);
  forceCSRFToken(config);

  return config;
}

export function createResponseInterceptor(config: ISamoletConfiguration) {
  let refreshPromise: Promise<void> | undefined = undefined;

  return () => {
    if (refreshPromise) return refreshPromise;

    refreshPromise = runInsideLock(() => runRefreshProcess(config));

    refreshPromise.finally(() => {
      refreshPromise = undefined;
    });

    return refreshPromise;
  };
}
